export default __webpack_public_path__ + "static/media/hand.3370b1c6.jpg";